export const toCentavos = (valorEmReais: number) => valorEmReais * 100.0;

export const toReais = (valorEmCentavos: number) => valorEmCentavos / 100.0;
